import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LogoutPage.css"

const LogoutPage = () => {
    const [message, setMessage] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        const reason = localStorage.getItem("logoutReason");
        if (reason === "inactivity") {
            setMessage("You have been logged out due to inactivity.");
        } else if (reason === "voluntary") {
            setMessage("Thank you for using our service. You have successfully logged out.");
        } else {
            navigate("/");
        }
        return () => {
            localStorage.removeItem("logoutReason");
        };
    }, [navigate]);

    return (
        <div className="logout-page">
            <div className="logout-message-container">
                <h1>{message}</h1>
                <button onClick={() => navigate("/")}>Sign In Again</button>
            </div>
        </div>
    );
};

export default LogoutPage;
